import { createRoot } from 'react-dom/client';
import BuilderApp from '../BuilderApp.jsx';

const initHavenlyticsAdminPropertyBuilder = () => {
  const container = document.getElementById('HvnlyNab_property_builder_render');
  if (!container) return;

  const root = createRoot(container);
  root.render(<BuilderApp />);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHavenlyticsAdminPropertyBuilder);
} else {
  initHavenlyticsAdminPropertyBuilder();
}

export default initHavenlyticsAdminPropertyBuilder;
